<template>
	<div class="nfl-weekly-pickem-home-page">
		<div class="nfl-weekly-pickem-home-page__content">
			<div class="pool-data" v-if="entries.length > 0">
				<h3 class="pool-name">{{ pool.name }}</h3>
				<router-link class="pool-data--make-picks" :to="{ name: 'nfl-weekly-pickems-manage-entry', params: { poolId: pool.id, entryId: userEntryId, weekId: currentUserEntryWeek } }">Make Picks</router-link>
				<div class="standings">
					<select class="standings--select" v-model="selectedWeek">
						<option value="0" default>Overall</option>
						<option v-for="index in currentWeek" :key="index" :value="index">Week {{ index }}</option>
					</select>
					<table class="standings--table">
						<tr class="header-row">
							<th class="position"></th>
							<th class="name">Team</th>
							<th class="record">Record</th>
						</tr>
						<tr class="entry-row" v-for="(entry, index) in getEntryWeekSortedByWins" :key="index">
							<td class="position">{{ entry.position }}</td>
							<td class="name">
								<router-link class="entry-name-link" :to="{ name: 'view-nfl-weekly-pickem-entry-week', params: { pickemId: pool.id, entryId: entry.entry_id, weekId: entry.id} }" v-if="selectedWeek != 0">
									<p>{{ entry.name }}</p>
									<i class="material-icons right-arrow">keyboard_arrow_right</i>
								</router-link>
								<p v-else>{{ entry.name }}</p>
							</td>
							<td class="record">{{ entry.wins }} - {{ entry.losses }}</td>
						</tr>
					</table>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations } from 'vuex'
	import axios from '@/axios'

	export default {
		props: ['poolId'],
		data() {
			return {
				pool: null,
				entries: [],
				selectedWeek: 0,
				currentWeek: 0
			}
		},
		computed: {
			userEntryId() {
				var id = 0
				if(this.entries.length > 0) {
					return this.userEntry.id
				}

				return id
			},
			userEntry() {
				var entry
				if(this.entries.length > 0) {
					this.entries.forEach(function(element) {
						if(element.current_user_entry) {
							entry = element
						}
					})
				}
				return entry
			},
			currentUserEntryWeek() {
				var id = 0
				this.userEntry.weeks.forEach((week) => {
					if (week.week_number == this.currentWeek) {
						id = week.id
					}
				})
				return id
			},
			getEntryWeekSortedByWins() {
				var entries = []
				this.entries.forEach((entry) => {
					var name = ''
					var wins = 0
					var losses = 0
					var id
					entry.users.forEach((user, index) => {
						if (index == 0) {
							name = user.user.name
						} else if (index == entry.users.length - 1 && entry.users.length > 2) {
							name = name.concat(user.user.name)
						} else {
							name = name.concat(' / ').concat(user.user.name)
						}
					})

					entry.weeks.forEach((entryWeek) => {
						if (entryWeek.week_number == this.selectedWeek) {
							wins = entryWeek.wins
							losses = entryWeek.losses
							id = entryWeek.id
						}
						if (this.selectedWeek == 0) {
							wins = wins + entryWeek.wins
							losses = losses + entryWeek.losses
						}
					})

					var info = {
						id: id,
						entry_id: entry.id,
						name: name,
						wins: wins,
						losses: losses,
						position: ''
					}

					entries.push(info)
				})

				entries.sort(function(a,b) {
					return b.wins - a.wins
				})

				var position = 1
				if (entries.length == 1) {
					entries[0].position = '1'
				} else {
					entries.forEach((entry, index) => {
						if (index == 0) {
							if (entry.wins == entries[1].wins) {
								entry.position = 'T' + position
							} else {
								entry.position = position.toString()
							}
						} else if (index < (entries.length - 1)) {
							if (entry.wins == entries[index - 1].wins) {
								entry.position = 'T' + position
							}
							if (entry.wins < entries[index - 1].wins) {
								position = (index + 1)
								if (entry.wins == entries[index + 1].wins) {
									entry.position = 'T' + position
								} else {
									entry.position = position.toString()
								}
							}
						} else if (index == (entries.length - 1)) {
							if (entry.wins == entries[index - 1].wins) {
								entry.position = 'T' + position
							} else {
								position = index + 1
								entry.position = position.toString()
							}
						}
					})
				}
				return entries
			}
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			getNflWeeklyPickem() {
				return axios.get('nfl-weekly-pickems/' + this.poolId).then((response) => {
					this.pool = response.data.data
					this.selectedWeek = this.pool.nfl_season.current_nfl_week.week_number
					this.currentWeek = this.pool.nfl_season.current_nfl_week.week_number

				})
			},
			getNflWeeklyPickemEntries() {
				return axios.get('nfl-weekly-pickems/' + this.poolId + '/nfl-weekly-pickem-entries').then((response) => {
					this.entries = response.data
				})
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getNflWeeklyPickem().then(() => {
				this.getNflWeeklyPickemEntries().then(() => {
					this.HTTP_FINISHED()
				})
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		},
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/nfl/nfl-weekly-pickem/home';
</style>